import styled from '@emotion/styled';
import P2 from '@base/P2/P2';
import { mediaQuery, Spacings } from '@styles/index';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import Button from '@base/Button/Button';
import Image from '@base/Image';

const ErrorDiv = styled.div`
  display: flex;
  align-items: center;
`;
const ErrorMsg = styled(P2)`
  color: var(--color-i-red);
  margin-left: ${Spacings.SPACING_2B};
  width: 272px;
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const ErrorImage = styled(Image)``;

const FooterWrapper = styled.div`
  grid-column: span 10;
  background: var(--color-base-1);
  display: flex;
  justify-content: space-between;
  padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_10B};
  align-items: center;
  box-shadow: ${boxShadowGenerator({ yOffset: '-16px', blur: '32px' })};
  ${mediaQuery.uptoMobile} {
    display: flex;
    flex-direction: column;
    padding: ${Spacings.SPACING_4B};
  }
`;

const StyButton = styled(Button)`
  margin-right: ${Spacings.SPACING_19B};
  color: var(--color-base-1);
  ${mediaQuery.uptoMobile} {
    width: 100%;
    margin-right: ${Spacings.SPACING_0B};
  }
`;

const Footer = ({
  errorMsg,
  onNextClick,
  buttonText,
  buttonWidth,
  isFooterButtonDisabled
}) => {
  return (
    <FooterWrapper>
      <ErrorDiv>
        {errorMsg ? (
          <ErrorImage
            src="oneToOneLiveMentoring/errorExclamation.svg"
            width={Spacings.SPACING_6B}
            height={Spacings.SPACING_6B}
            alt="error"
          />
        ) : null}
        <ErrorMsg>{errorMsg || ''}</ErrorMsg>
      </ErrorDiv>
      <StyButton
        label={buttonText}
        variant={isFooterButtonDisabled ? 'disabled' : 'filled'}
        color="black"
        width={buttonWidth}
        onClick={onNextClick}
        fontSize="14px"
      />
    </FooterWrapper>
  );
};

export default Footer;
